import { NgxLoggerLevel } from 'ngx-logging-kit';

export interface IUrl {
	url: string;
	port?: string;
	subDirectory?: string;
}

export class BaseUrl {
	private readonly url: string;
	private readonly port?: string;
	private readonly subDirectory?: string;

	constructor(paramaters: IUrl) {
		this.url = paramaters.url;
		this.port = paramaters.port;
		this.subDirectory = paramaters.subDirectory;
	}
	/**
	 *  get url with port if available
	 */
	public getFullUrl(): string {
		let url = this.url;
		if (this.port) {
			url += `:${this.port}`;
		}
		return url;
	}

	public toString(): string {
		let url = this.url;
		if (this.port) {
			url += `:${this.port}`;
		}
		if (this.subDirectory) {
			url += `/${this.subDirectory}`;
		}
		return url;
	}
}

export interface ENV {
	production: boolean;
	baseURL: BaseUrl;
	applicationId: string;
	loggerConfig: {
		level: NgxLoggerLevel;
		timestampFormat: string;
	};
	i18n: {
		languages: string[];
		defaultLanguage: string;
	};
	Oauth2: {
		CLIENT_SECRET: string;
		CLIENT_ID: string;
	};
}
